import type { ChatState } from './interfaces';

export function inputReducer(state: string, action: ChatState.Action): string {

  switch (action.type) {

    case 'input-changed':
      return action.payload.value;

    case 'input-appended': {
      const trimmed = state.trimEnd();
      const separator = trimmed.length > 0 ? ', ' : '';
      return `${trimmed}${separator}${action.payload.value}`;
    }

    case 'query-submitted':
      return '';

    case 'kol-search/question-bank-question-selected':
      return action.payload.value;

    default:
      return state;
  }
}